import ResourceManager, { ActiveBadge } from "@/components/admin/ResourceManager";

const fields = [
    { name: "title", label: "Title", type: "text", required: true },
    { name: "slug", label: "Slug", type: "text", help: "Leave empty to auto-generate from title" },
    { name: "icon", label: "Icon (lucide name)", type: "text", placeholder: "globe, smartphone, message-circle..." },
    { name: "short_description", label: "Short description", type: "textarea", rows: 2, required: true },
    { name: "full_description", label: "Full description", type: "markdown", rows: 8, required: true },
    { name: "featured_image", label: "Featured image", type: "image" },
    { name: "benefits", label: "Benefits", type: "tags", help: "One benefit per line" },
    { name: "features", label: "Features", type: "tags", help: "One feature per line" },
    { name: "process_steps", label: "Process steps", type: "process_steps" },
    { name: "cta_text", label: "CTA text", type: "text", default: "Get a free quote" },
    { name: "order", label: "Sort order", type: "number" },
    { name: "is_active", label: "Active", type: "switch", default: true, toggleLabel: "Visible on site" },
    { name: "seo_title", label: "SEO title", type: "text" },
    { name: "seo_description", label: "SEO description", type: "textarea", rows: 2 },
    { name: "og_image", label: "Open Graph image", type: "image" },
];

const columns = [
    { key: "title", label: "Title" },
    { key: "slug", label: "Slug", render: (r) => <code className="text-xs text-slate-500">{r.slug}</code> },
    { key: "is_active", label: "Status", render: (r) => <ActiveBadge active={r.is_active} /> },
    { key: "order", label: "Order" },
];

export default function ServicesPage() {
    return (
        <ResourceManager
            title="Services"
            description="The 7 paid services you offer to UK small businesses."
            endpoint="services"
            columns={columns}
            fields={fields}
            testidPrefix="services"
        />
    );
}
